/* ============================================================
   script.js — Solar Batteries Brisbane landing page
   ============================================================ */

// AOS scroll animations — only init if the library was loaded (opt-in via $useAos)
window.addEventListener("load", () => {
  if (typeof AOS !== "undefined") {
    AOS.init({ disable: "mobile" });
  }
});

// Block empty-hash anchors
document.querySelectorAll('a[href="#"]').forEach((link) => {
  link.addEventListener("click", (e) => e.preventDefault());
});

// Smooth scroll for in-page anchors (but NOT #consultation — that opens the modal)
document.querySelectorAll('a[href^="#"]:not([href="#"]):not([href="#consultation"])').forEach((link) => {
  link.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href").slice(1);
    const target = document.getElementById(targetId);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
    }
  });
});

// ===== Mobile hamburger menu =====
(function () {
  var burger = document.getElementById("hamburger");
  var menu = document.getElementById("navMenu");
  if (!burger || !menu) return;
  burger.addEventListener("click", function () {
    var open = menu.classList.toggle("hidden") === false;
    burger.setAttribute("aria-expanded", open ? "true" : "false");
  });
  menu.querySelectorAll("a").forEach(function (a) {
    a.addEventListener("click", function () {
      menu.classList.add("hidden");
      burger.setAttribute("aria-expanded", "false");
    });
  });
})();

// ===== Solution tabs =====
document.querySelectorAll(".tab-trigger").forEach(function (btn) {
  btn.addEventListener("click", function () {
    var id = btn.dataset.tab;
    document.querySelectorAll(".tab-trigger").forEach(function (b) { b.classList.toggle("active", b === btn); });
    document.querySelectorAll(".tab-panel").forEach(function (p) { p.classList.toggle("active", p.id === id); });
  });
});

// ===== Process tags: scatter-stack when scrolled into view =====
(function () {
  var ptags = document.querySelector(".proc-tags");
  if (!ptags) return;
  if (!("IntersectionObserver" in window)) { ptags.classList.add("animate"); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { ptags.classList.add("animate"); io.disconnect(); }
    });
  }, { threshold: 0.2 });
  io.observe(ptags);
})();

// ===== Quote modal: 3-step form + savings calculator =====
(function () {
  var modal = document.getElementById("quoteModal");
  if (!modal) return;
  var form = document.getElementById("quoteForm");
  var steps = [].slice.call(modal.querySelectorAll(".qm-step"));
  var dots = [].slice.call(modal.querySelectorAll(".qm-steps .s"));
  var bill = document.getElementById("qmBill"), billOut = document.getElementById("qmBillOut");
  var saveOut = document.getElementById("qmSaveOut"), saveRange = document.getElementById("qmSaveRange");
  var cur = 0;

  function render() {
    steps.forEach(function (s, k) { s.classList.toggle("active", k === cur); });
    dots.forEach(function (d, k) { d.classList.toggle("active", k === cur); d.classList.toggle("done", k < cur); });
    if (cur === 1) calc();
  }
  function go(i) { cur = Math.max(0, Math.min(steps.length - 1, i)); render(); }
  function openM() {
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    cur = 0; render();
    setTimeout(function () { var f = steps[0].querySelector("input"); if (f) f.focus(); }, 60);
  }
  function closeM() {
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  document.querySelectorAll('a[href="#consultation"]').forEach(function (a) {
    a.addEventListener("click", function (e) { e.preventDefault(); openM(); });
  });
  document.getElementById("qmClose").addEventListener("click", closeM);
  modal.addEventListener("mousedown", function (e) { if (e.target === modal) closeM(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("open")) closeM(); });
  modal.querySelectorAll(".qm-next").forEach(function (b) { b.addEventListener("click", function () { go(cur + 1); }); });
  modal.querySelectorAll(".qm-back").forEach(function (b) { b.addEventListener("click", function () { go(cur - 1); }); });

  function calc() {
    var q = +bill.value, annual = q * 4;
    if (billOut) billOut.textContent = "$" + q;
    var solar = (form.elements["solar"] && form.elements["solar"].value) || "yes";
    var ev = (form.elements["evening"] && form.elements["evening"].value) || "med";
    var off = ev === "high" ? 0.38 : ev === "low" ? 0.2 : 0.3;
    if (solar === "no") off += 0.03;
    var r = function (v) { return Math.round((annual * v) / 10) * 10; };
    var f = function (n) { return "$" + n.toLocaleString(); };
    var mid = r(off), lo = r(Math.max(0.13, off - 0.07)), hi = r(off + 0.05);
    if (saveOut) saveOut.textContent = f(mid);
    if (saveRange) saveRange.textContent = "Indicative range " + f(lo) + "–" + f(hi) + " per year";
    modal.dataset.est = f(mid) + " per year";
  }
  form.addEventListener("input", function () { if (cur === 1) calc(); });
  form.addEventListener("change", function () { if (cur === 1) calc(); });

  // Native POST to partials/quote-form on submit (after validation)
  form.addEventListener("submit", function (e) {
    var name = (form.elements["name"].value || "").trim();
    var phone = (form.elements["phone"].value || "").trim();
    if (!name) { e.preventDefault(); go(2); form.elements["name"].focus(); return; }
    if (!phone) { e.preventDefault(); go(2); form.elements["phone"].focus(); return; }
    var est = document.getElementById("qmEstimate");
    if (est) est.value = modal.dataset.est || "";
    // allow default submit
  });
})();

// ===== Hero inline booking form (3-step) =====
(function () {
  var form = document.getElementById("heroForm");
  if (!form) return;
  var card = form.closest("aside");
  var steps = [].slice.call(form.querySelectorAll(".hf-step"));
  var dots = [].slice.call(document.querySelectorAll("#hfProg .dot"));
  var bars = [].slice.call(document.querySelectorAll("#hfProg .bar"));
  var cur = 0;

  function showStep(i) {
    cur = Math.max(0, Math.min(steps.length - 1, i));
    steps.forEach(function (s, k) { s.classList.toggle("active", k === cur); });
    dots.forEach(function (d, k) { d.classList.toggle("active", k === cur); d.classList.toggle("done", k < cur); });
    bars.forEach(function (b, k) { b.classList.toggle("done", k < cur); });
    if (cur === 1) calc();
  }

  // ---- product carousel ----
  var track = document.getElementById("hfTrack");
  var slides = [].slice.call(track.children);
  var dotsWrap = document.getElementById("hfDots");
  var pick = document.getElementById("hfPick");
  var batteryInput = document.getElementById("hfBattery");
  var ci = 0, GAP = 16;
  slides.forEach(function (s, k) {
    s.addEventListener("click", function () { goTo(k); });
    var b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", "Show battery " + (k + 1));
    b.className = "size-[9px] rounded-full bg-line transition-all duration-500" + (k === 0 ? " active" : "");
    b.addEventListener("click", function () { goTo(k); });
    dotsWrap.appendChild(b);
  });
  function goTo(k) {
    ci = (k + slides.length) % slides.length;
    var vw = track.parentElement.clientWidth;
    var sw = slides[0].getBoundingClientRect().width + GAP;
    var max = Math.max(0, track.scrollWidth - vw);
    var shift = Math.max(0, Math.min(ci * sw, max));
    track.style.transform = "translateX(-" + shift + "px)";
    [].slice.call(dotsWrap.children).forEach(function (d, j) { d.classList.toggle("active", j === ci); });
    slides.forEach(function (s, j) { s.classList.toggle("is-active", j === ci); });
    var name = slides[ci].getAttribute("data-name");
    pick.textContent = name;
    batteryInput.value = name;
  }
  document.getElementById("hfPrev").addEventListener("click", function () { goTo(ci - 1); });
  document.getElementById("hfNext").addEventListener("click", function () { goTo(ci + 1); });

  // ---- savings calculator ----
  var bill = document.getElementById("hfBill"), billOut = document.getElementById("hfBillOut");
  var saveOut = document.getElementById("hfSaveOut"), saveRange = document.getElementById("hfSaveRange");
  function calc() {
    var q = +bill.value, annual = q * 4;
    billOut.textContent = "$" + q;
    var ev = (form.elements["evening"] && form.elements["evening"].value) || "med";
    var off = ev === "high" ? 0.38 : ev === "low" ? 0.2 : 0.3;
    var r = function (v) { return Math.round((annual * v) / 10) * 10; };
    var f = function (n) { return "$" + n.toLocaleString(); };
    var mid = r(off), lo = r(Math.max(0.13, off - 0.07)), hi = r(off + 0.05);
    saveOut.textContent = f(mid);
    saveRange.textContent = "Range " + f(lo) + "–" + f(hi) + " / year";
    card.dataset.est = f(mid) + " per year";
  }
  form.addEventListener("input", function () { if (cur === 1) calc(); });
  form.addEventListener("change", function () { if (cur === 1) calc(); });

  // ---- preferred-day chips (next 4 days, skip Sundays) ----
  var daysWrap = document.getElementById("hfDays");
  var wd = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var mo = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var now = new Date(), added = 0, off = 1;
  while (added < 4 && off < 10) {
    var dt = new Date(now.getTime() + off * 86400000);
    if (dt.getDay() !== 0) {
      var label = wd[dt.getDay()] + " " + dt.getDate() + " " + mo[dt.getMonth()];
      var lab = document.createElement("label");
      lab.className = "relative cursor-pointer";
      lab.innerHTML =
        '<input type="radio" name="day" value="' + label + '"' + (added === 0 ? " checked" : "") +
        ' class="peer sr-only"><span class="inline-block rounded-full border border-line px-[18px] py-2.5 text-[1.1rem] font-semibold text-muted transition peer-checked:border-green peer-checked:bg-green peer-checked:text-navydeep">' +
        label + "</span>";
      daysWrap.appendChild(lab);
      added++;
    }
    off++;
  }

  // ---- step navigation ----
  function validateDetails() {
    var n = form.elements["name"], p = form.elements["phone"];
    if (!n.value.trim()) { n.classList.add("hf-err"); n.focus(); return false; }
    if (!p.value.trim()) { p.classList.add("hf-err"); p.focus(); return false; }
    return true;
  }
  form.querySelectorAll("[data-go]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var to = +btn.getAttribute("data-go");
      if (to > cur && cur === 1 && !validateDetails()) return;
      showStep(to);
    });
  });
  form.querySelectorAll(".hf-input").forEach(function (inp) {
    inp.addEventListener("input", function () { inp.classList.remove("hf-err"); });
  });

  // ---- book (native POST to partials/form) ----
  form.addEventListener("submit", function (e) {
    if (!validateDetails()) { e.preventDefault(); showStep(1); return; }
    var est = document.getElementById("hfEstimate");
    if (est) est.value = card.dataset.est || "";
    // allow default submit
  });

  // init
  goTo(0);
  showStep(0);
})();

// ===== Feature showcase: auto image carousel + scrolling items + loader =====
(function () {
  var show = document.getElementById("featureShow");
  if (!show) return;
  var imgs = [].slice.call(show.querySelectorAll(".fs-img"));
  var track = document.getElementById("fsTrack");
  var items = [].slice.call(track.children);
  var dotsWrap = document.getElementById("fsDots");
  var bar = document.getElementById("fsBar");
  var n = items.length, idx = 0, timer = null;
  var INTERVAL = 3000;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches;
  items.forEach(function (it, i) {
    var b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", "Show point " + (i + 1));
    b.className = "size-2 rounded-full bg-white/50 transition-all duration-500" + (i === 0 ? " active" : "");
    b.addEventListener("click", function () { go(i); if (!reduce) restart(); });
    dotsWrap.appendChild(b);
  });
  function render() {
    track.style.transform = "translateY(-" + idx * (100 / n) + "%)";
    imgs.forEach(function (im, i) { im.classList.toggle("is-active", i === idx); });
    [].slice.call(dotsWrap.children).forEach(function (d, i) { d.classList.toggle("active", i === idx); });
  }
  function fillBar() {
    if (!bar || reduce) return;
    bar.style.transition = "none";
    bar.style.width = "0%";
    void bar.offsetWidth;
    bar.style.transition = "width " + INTERVAL / 1000 + "s linear";
    bar.style.width = "100%";
  }
  function go(i) { idx = (i + n) % n; render(); fillBar(); }
  function advance() { go(idx + 1); }
  function start() { if (reduce || timer) return; fillBar(); timer = setInterval(advance, INTERVAL); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function restart() { stop(); start(); }
  show.addEventListener("mouseenter", function () {
    stop();
    if (bar && !reduce) { var w = getComputedStyle(bar).width; bar.style.transition = "none"; bar.style.width = w; }
  });
  show.addEventListener("mouseleave", start);
  render();
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.25 });
    io.observe(show);
  } else {
    start();
  }
})();
